import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'daterangeformatter'
})
export class DateFormatter implements PipeTransform {
  transform(value: any,format?:any, tz?:any): string {
    console.log(value, format, tz, "in pipe..........")
    if (value) {
      if(format){
        if(tz){
          return value.tz(tz).format(format);
        }
        return value.format(format);
      }
      if(tz){
        return value.tz(tz).format("DD MMM YYYY HH:mm:ss");
      }
      return value.format("DD MMM YYYY HH:mm:ss");
    } else {
      return "-";
    }
  }
}
